import BillingsPlanEntryTaxiDriverRecalculateResponse, {
  BillingsPlanEntryTaxiDriverRecalculateResponseDataBillingNode,
  BillingsPlanEntryTaxiDriverRecalculateResponseDataContract,
  BillingsPlanEntryTaxiDriverRecalculateResponseDataContractTaxiDriverAssociation,
  BillingsPlanEntryTaxiDriverRecalculateResponseDataContractTaxiDriverAssociationDriver,
  BillingsPlanEntryTaxiDriverRecalculateResponseDataContractTaxiDriverAssociationDriverStartingAddress,
  BillingsPlanEntryTaxiDriverRecalculateResponseDataContractTaxiDriverAssociationDriverUser,
  BillingsPlanEntryTaxiDriverRecalculateResponseDataContractTaxiDriverAssociationFleetPartner,
  BillingsPlanEntryTaxiDriverRecalculateResponseDataPlanEntry,
  BillingsPlanEntryTaxiDriverRecalculateResponseDataPlanEntrySolvedOrder,
  BillingsPlanEntryTaxiDriverRecalculateResponseDataPlanEntrySolvedOrderTransportingOrder,
  BillingsPlanEntryTaxiDriverRecalculateResponseDataPlanEntrySolvedOrderTransportingOrderCargoOrder,
  BillingsPlanEntryTaxiDriverRecalculateResponseDataBonusContribution,
  BillingsPlanEntryTaxiDriverRecalculateResponseDataBonusContributionFavorableDistance,
  BillingsPlanEntryTaxiDriverRecalculateResponseDataBonusContributionOther,
  BillingsPlanEntryTaxiDriverRecalculateResponseDataContractCorrectionContribution,
  BillingsPlanEntryTaxiDriverRecalculateResponseDataContractCorrectionContributionBaseAmountExternalTaxi,
  BillingsPlanEntryTaxiDriverRecalculateResponseDataContractCorrectionContributionOtherRate,
  BillingsPlanEntryTaxiDriverRecalculateResponseDataContribution,
  BillingsPlanEntryTaxiDriverRecalculateResponseDataContributionType,
  BillingsPlanEntryTaxiDriverRecalculateResponseDataPenaltyContribution,
  BillingsPlanEntryTaxiDriverRecalculateResponseDataPenaltyContributionBeingLate,
  BillingsPlanEntryTaxiDriverRecalculateResponseDataPenaltyContributionIncompatibleCar,
  BillingsPlanEntryTaxiDriverRecalculateResponseDataPenaltyContributionOther,
  BillingsPlanEntryTaxiDriverRecalculateResponseDataPenaltyContributionWrongRoute,
} from "../../../../../api/raily/billings/plan-entry/taxi-driver/recalculate/billings-plan-entry-taxi-driver-recalculate.response";
import BillingsPlanEntryTaxiDriverRecalculate, {
  BillingsPlanEntryTaxiDriverRecalculateBillingNode,
  BillingsPlanEntryTaxiDriverRecalculateBonusContribution,
  BillingsPlanEntryTaxiDriverRecalculateBonusContributionFavorableDistance,
  BillingsPlanEntryTaxiDriverRecalculateBonusContributionOther,
  BillingsPlanEntryTaxiDriverRecalculateContract,
  BillingsPlanEntryTaxiDriverRecalculateContractCorrectionContribution,
  BillingsPlanEntryTaxiDriverRecalculateContractCorrectionContributionBaseAmountExternalTaxi,
  BillingsPlanEntryTaxiDriverRecalculateContractCorrectionContributionOtherRate,
  BillingsPlanEntryTaxiDriverRecalculateContractTaxiDriverAssociation,
  BillingsPlanEntryTaxiDriverRecalculateContractTaxiDriverAssociationDriver,
  BillingsPlanEntryTaxiDriverRecalculateContractTaxiDriverAssociationDriverStartingAddress,
  BillingsPlanEntryTaxiDriverRecalculateContractTaxiDriverAssociationDriverUser,
  BillingsPlanEntryTaxiDriverRecalculateContractTaxiDriverAssociationFleetPartner,
  BillingsPlanEntryTaxiDriverRecalculateContribution,
  BillingsPlanEntryTaxiDriverRecalculateContributionType,
  BillingsPlanEntryTaxiDriverRecalculatePenaltyContribution,
  BillingsPlanEntryTaxiDriverRecalculatePenaltyContributionBeingLate,
  BillingsPlanEntryTaxiDriverRecalculatePenaltyContributionIncompatibleCar,
  BillingsPlanEntryTaxiDriverRecalculatePenaltyContributionOther,
  BillingsPlanEntryTaxiDriverRecalculatePenaltyContributionWrongRoute,
  BillingsPlanEntryTaxiDriverRecalculatePlanEntry,
  BillingsPlanEntryTaxiDriverRecalculatePlanEntrySolvedOrder,
} from "./billings-plan-entry-taxi-driver-recalculate";

const createBillingBonusContributionFavorableDistance = (
  contribution: BillingsPlanEntryTaxiDriverRecalculateResponseDataBonusContributionFavorableDistance,
): BillingsPlanEntryTaxiDriverRecalculateBonusContributionFavorableDistance => {
  return {
    comment: contribution.comment,
    distance: contribution.distance,
    rate: contribution.rate,
    type: BillingsPlanEntryTaxiDriverRecalculateContributionType.BONUS_FAVORABLE_DISTANCE,
  };
};

const createBillingBonusContributionOther = (
  contribution: BillingsPlanEntryTaxiDriverRecalculateResponseDataBonusContributionOther,
): BillingsPlanEntryTaxiDriverRecalculateBonusContributionOther => {
  return {
    amount: contribution.amount,
    comment: contribution.comment,
    type: BillingsPlanEntryTaxiDriverRecalculateContributionType.BONUS_OTHER,
  };
};

const createBillingBonusContribution = (
  contribution: BillingsPlanEntryTaxiDriverRecalculateResponseDataBonusContribution,
): BillingsPlanEntryTaxiDriverRecalculateBonusContribution => {
  switch (contribution.type) {
    case BillingsPlanEntryTaxiDriverRecalculateResponseDataContributionType.BONUS_FAVORABLE_DISTANCE:
      return createBillingBonusContributionFavorableDistance(
        contribution as BillingsPlanEntryTaxiDriverRecalculateResponseDataBonusContributionFavorableDistance,
      );
    case BillingsPlanEntryTaxiDriverRecalculateResponseDataContributionType.BONUS_OTHER:
      return createBillingBonusContributionOther(
        contribution as BillingsPlanEntryTaxiDriverRecalculateResponseDataBonusContributionOther,
      );
  }
};

const createBillingPenaltyOther = (
  contribution: BillingsPlanEntryTaxiDriverRecalculateResponseDataPenaltyContributionOther,
): BillingsPlanEntryTaxiDriverRecalculatePenaltyContributionOther => {
  return {
    amount: contribution.amount,
    comment: contribution.comment,
    type: BillingsPlanEntryTaxiDriverRecalculateContributionType.PENALTY_OTHER,
  };
};

const createBillingPenaltyIncompatibleCar = (
  contribution: BillingsPlanEntryTaxiDriverRecalculateResponseDataPenaltyContributionIncompatibleCar,
): BillingsPlanEntryTaxiDriverRecalculatePenaltyContributionIncompatibleCar => {
  return {
    amount: contribution.amount,
    comment: contribution.comment,
    type: BillingsPlanEntryTaxiDriverRecalculateContributionType.PENALTY_INCOMPATIBLE_CAR,
  };
};

const createBillingPenaltyBeingLate = (
  contribution: BillingsPlanEntryTaxiDriverRecalculateResponseDataPenaltyContributionBeingLate,
): BillingsPlanEntryTaxiDriverRecalculatePenaltyContributionBeingLate => {
  return {
    amount: contribution.amount,
    comment: contribution.comment,
    type: BillingsPlanEntryTaxiDriverRecalculateContributionType.PENALTY_BEING_LATE,
  };
};

const createBillingPenaltyWrongRoute = (
  contribution: BillingsPlanEntryTaxiDriverRecalculateResponseDataPenaltyContributionWrongRoute,
): BillingsPlanEntryTaxiDriverRecalculatePenaltyContributionWrongRoute => {
  return {
    amount: contribution.amount,
    comment: contribution.comment,
    type: BillingsPlanEntryTaxiDriverRecalculateContributionType.PENALTY_WRONG_ROUTE,
  };
};

const createBillingPenaltyContribution = (
  contribution: BillingsPlanEntryTaxiDriverRecalculateResponseDataPenaltyContribution,
): BillingsPlanEntryTaxiDriverRecalculatePenaltyContribution => {
  switch (contribution.type) {
    case BillingsPlanEntryTaxiDriverRecalculateResponseDataContributionType.PENALTY_BEING_LATE:
      return createBillingPenaltyBeingLate(
        contribution as BillingsPlanEntryTaxiDriverRecalculateResponseDataPenaltyContributionBeingLate,
      );
    case BillingsPlanEntryTaxiDriverRecalculateResponseDataContributionType.PENALTY_OTHER:
      return createBillingPenaltyOther(
        contribution as BillingsPlanEntryTaxiDriverRecalculateResponseDataPenaltyContributionOther,
      );
    case BillingsPlanEntryTaxiDriverRecalculateResponseDataContributionType.PENALTY_INCOMPATIBLE_CAR:
      return createBillingPenaltyIncompatibleCar(
        contribution as BillingsPlanEntryTaxiDriverRecalculateResponseDataPenaltyContributionIncompatibleCar,
      );
    case BillingsPlanEntryTaxiDriverRecalculateResponseDataContributionType.PENALTY_WRONG_ROUTE:
      return createBillingPenaltyWrongRoute(
        contribution as BillingsPlanEntryTaxiDriverRecalculateResponseDataPenaltyContributionWrongRoute,
      );
  }
};

const createBillingContractCorrectionContributionBaseAmountExternalTaxi = (
  contribution: BillingsPlanEntryTaxiDriverRecalculateResponseDataContractCorrectionContributionBaseAmountExternalTaxi,
): BillingsPlanEntryTaxiDriverRecalculateContractCorrectionContributionBaseAmountExternalTaxi => {
  return {
    amount: contribution.amount,
    distance: contribution.distance,
    type: BillingsPlanEntryTaxiDriverRecalculateContributionType.BASE_AMOUNT_EXTERNAL_TAXI,
  };
};

const createBillingContractCorrectionContributionOtherRate = (
  contribution: BillingsPlanEntryTaxiDriverRecalculateResponseDataContractCorrectionContributionOtherRate,
): BillingsPlanEntryTaxiDriverRecalculateContractCorrectionContributionOtherRate => {
  return {
    rate: contribution.rate,
    type: BillingsPlanEntryTaxiDriverRecalculateContributionType.CONTRACT_CORRECTION_RATE,
  };
};

const createBillingContractCorrectionContribution = (
  contribution: BillingsPlanEntryTaxiDriverRecalculateResponseDataContractCorrectionContribution,
): BillingsPlanEntryTaxiDriverRecalculateContractCorrectionContribution => {
  switch (contribution.type) {
    case BillingsPlanEntryTaxiDriverRecalculateResponseDataContributionType.BASE_AMOUNT_EXTERNAL_TAXI:
      return createBillingContractCorrectionContributionBaseAmountExternalTaxi(
        contribution as BillingsPlanEntryTaxiDriverRecalculateResponseDataContractCorrectionContributionBaseAmountExternalTaxi,
      );
    case BillingsPlanEntryTaxiDriverRecalculateResponseDataContributionType.CONTRACT_CORRECTION_RATE:
      return createBillingContractCorrectionContributionOtherRate(
        contribution as BillingsPlanEntryTaxiDriverRecalculateResponseDataContractCorrectionContributionOtherRate,
      );
  }
};

const createBillingContribution = (
  contribution: BillingsPlanEntryTaxiDriverRecalculateResponseDataContribution,
): BillingsPlanEntryTaxiDriverRecalculateContribution => {
  switch (contribution.type) {
    case BillingsPlanEntryTaxiDriverRecalculateResponseDataContributionType.BONUS_FAVORABLE_DISTANCE:
    case BillingsPlanEntryTaxiDriverRecalculateResponseDataContributionType.BONUS_OTHER:
      return createBillingBonusContribution(
        contribution as BillingsPlanEntryTaxiDriverRecalculateResponseDataBonusContribution,
      );
    case BillingsPlanEntryTaxiDriverRecalculateResponseDataContributionType.PENALTY_BEING_LATE:
    case BillingsPlanEntryTaxiDriverRecalculateResponseDataContributionType.PENALTY_OTHER:
    case BillingsPlanEntryTaxiDriverRecalculateResponseDataContributionType.PENALTY_INCOMPATIBLE_CAR:
    case BillingsPlanEntryTaxiDriverRecalculateResponseDataContributionType.PENALTY_WRONG_ROUTE:
      return createBillingPenaltyContribution(
        contribution as BillingsPlanEntryTaxiDriverRecalculateResponseDataPenaltyContribution,
      );
    case BillingsPlanEntryTaxiDriverRecalculateResponseDataContributionType.BASE_AMOUNT_EXTERNAL_TAXI:
    case BillingsPlanEntryTaxiDriverRecalculateResponseDataContributionType.CONTRACT_CORRECTION_RATE:
      return createBillingContractCorrectionContribution(
        contribution as BillingsPlanEntryTaxiDriverRecalculateResponseDataContractCorrectionContribution,
      );
  }
};

const createBillingContributions = (
  contributions: BillingsPlanEntryTaxiDriverRecalculateResponseDataContribution[],
): BillingsPlanEntryTaxiDriverRecalculateContribution[] => {
  return contributions.map(createBillingContribution);
};

const createContractTaxiDriverAssociationDriverUser = (
  user: BillingsPlanEntryTaxiDriverRecalculateResponseDataContractTaxiDriverAssociationDriverUser,
): BillingsPlanEntryTaxiDriverRecalculateContractTaxiDriverAssociationDriverUser => {
  return {
    firstName: user.firstName,
    lastName: user.lastName,
  };
};

const createContractTaxiDriverAssociationDriverStartingAddress = (
  startingAddress: BillingsPlanEntryTaxiDriverRecalculateResponseDataContractTaxiDriverAssociationDriverStartingAddress,
): BillingsPlanEntryTaxiDriverRecalculateContractTaxiDriverAssociationDriverStartingAddress => {
  return {
    displayName: startingAddress.displayName,
  };
};

const createContractTaxiDriverAssociationDriver = (
  driver: BillingsPlanEntryTaxiDriverRecalculateResponseDataContractTaxiDriverAssociationDriver,
): BillingsPlanEntryTaxiDriverRecalculateContractTaxiDriverAssociationDriver => {
  return {
    startingAddress: createContractTaxiDriverAssociationDriverStartingAddress(
      driver.startingAddress,
    ),
    user: createContractTaxiDriverAssociationDriverUser(driver.user),
  };
};

const createContractTaxiDriverAssociationFleetPartner = (
  taxiDriverAssociation: BillingsPlanEntryTaxiDriverRecalculateResponseDataContractTaxiDriverAssociationFleetPartner | null,
): BillingsPlanEntryTaxiDriverRecalculateContractTaxiDriverAssociationFleetPartner | null => {
  return {
    name: taxiDriverAssociation?.name ?? "",
  };
};

const createContractTaxiDriverAssociation = (
  taxiDriverAssociation: BillingsPlanEntryTaxiDriverRecalculateResponseDataContractTaxiDriverAssociation,
): BillingsPlanEntryTaxiDriverRecalculateContractTaxiDriverAssociation => {
  return {
    driver: createContractTaxiDriverAssociationDriver(
      taxiDriverAssociation.driver,
    ),
    fleetPartner: createContractTaxiDriverAssociationFleetPartner(
      taxiDriverAssociation.fleetPartner,
    ),
  };
};

const createContract = (
  contract: BillingsPlanEntryTaxiDriverRecalculateResponseDataContract,
): BillingsPlanEntryTaxiDriverRecalculateContract => {
  return {
    description: contract.description,
    distanceRate: contract.distanceRate,
    haltingTimeAfterMinutes: contract.haltingTimeAfterMinutes,
    haltingTimeRate: contract.haltingTimeRate,
    model: contract.model,
    taxiDriverAssociation: createContractTaxiDriverAssociation(
      contract.taxiDriverAssociation,
    ),
  };
};

const createBillingNode = (
  node: BillingsPlanEntryTaxiDriverRecalculateResponseDataBillingNode,
): BillingsPlanEntryTaxiDriverRecalculateBillingNode => {
  return {
    allowCharge: node.allowCharge,
    checkoutDate: node.checkoutDate,
    checkoutEventId: node.checkoutEventId,
    description: node.description,
    distance: node.distance,
    editableCoordinates: node.editableCoordinates,
    haltingTime: node.haltingTime,
    highwayCharge: node.highwayCharge,
    id: node.id,
    lat: node.lat,
    lon: node.lon,
    nodeId: node.nodeId,
    orderId: node.orderId,
    plannedDate: node.plannedDate,
    plannedDistance: node.plannedDistance,
  };
};

const createBillingNodes = (
  nodes: BillingsPlanEntryTaxiDriverRecalculateResponseDataBillingNode[],
): BillingsPlanEntryTaxiDriverRecalculateBillingNode[] => {
  return nodes.map(createBillingNode);
};

const createPlanEntrySolvedOrderTransportingOrderCargoOrder = (
  transportingOrder: BillingsPlanEntryTaxiDriverRecalculateResponseDataPlanEntrySolvedOrderTransportingOrderCargoOrder,
): BillingsPlanEntryTaxiDriverRecalculateResponseDataPlanEntrySolvedOrderTransportingOrderCargoOrder => {
  return {
    humanId: transportingOrder.humanId,
    id: transportingOrder.id,
  };
};

const createPlanEntrySolvedOrderTransportingOrder = (
  transportingOrder: BillingsPlanEntryTaxiDriverRecalculateResponseDataPlanEntrySolvedOrderTransportingOrder,
): BillingsPlanEntryTaxiDriverRecalculateResponseDataPlanEntrySolvedOrderTransportingOrder => {
  return {
    cargoOrder: createPlanEntrySolvedOrderTransportingOrderCargoOrder(
      transportingOrder.cargoOrder,
    ),
  };
};

const createPlanEntrySolvedOrder = (
  solvedOrder: BillingsPlanEntryTaxiDriverRecalculateResponseDataPlanEntrySolvedOrder,
): BillingsPlanEntryTaxiDriverRecalculatePlanEntrySolvedOrder => {
  return {
    transportingOrder: createPlanEntrySolvedOrderTransportingOrder(
      solvedOrder.transportingOrder,
    ),
  };
};

const createPlanEntrySolvedOrders = (
  solvedOrders: BillingsPlanEntryTaxiDriverRecalculateResponseDataPlanEntrySolvedOrder[],
): BillingsPlanEntryTaxiDriverRecalculatePlanEntrySolvedOrder[] => {
  return solvedOrders.map(createPlanEntrySolvedOrder);
};

const createPlanEntry = (
  planEntry: BillingsPlanEntryTaxiDriverRecalculateResponseDataPlanEntry,
): BillingsPlanEntryTaxiDriverRecalculatePlanEntry => {
  return {
    humanId: planEntry.humanId,
    solvedOrders: createPlanEntrySolvedOrders(planEntry.solvedOrders),
  };
};

const create = (
  response: BillingsPlanEntryTaxiDriverRecalculateResponse,
): BillingsPlanEntryTaxiDriverRecalculate => {
  const data = response.data;

  return {
    allContributionsAmount: data.allContributionsAmount,
    amountForChargeHaltings: data.amountForChargeHaltings,
    amountForChargeHighways: data.amountForChargeHighways,
    amountForDistance: data.amountForDistance,
    billingContributions: createBillingContributions(data.billingContributions),
    billingNodes: createBillingNodes(data.billingNodes),
    contract: createContract(data.contract),
    correctedContractModel: data.correctedContractModel,
    date: data.date,
    distance: data.distance,
    passengers: data.passengers,
    planEntry: createPlanEntry(data.planEntry),
    rateForDistance: data.rateForDistance,
    sumOfBonuses: data.sumOfBonuses,
    sumOfPenalties: data.sumOfPenalties,
  };
};

const billingsPlanEntryDriverRecalculateFactory = {
  create,
};

export default billingsPlanEntryDriverRecalculateFactory;
